module.exports = __webpack_public_path__ + "static/img/license-number.7d70784.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/license-number.png
// module id = qXkp
// module chunks = 1